import { render, staticRenderFns } from "./BookingService.vue?vue&type=template&id=f97a8f26&scoped=true&"
import script from "./BookingService.vue?vue&type=script&lang=js&"
export * from "./BookingService.vue?vue&type=script&lang=js&"
import style0 from "./BookingService.vue?vue&type=style&index=0&id=f97a8f26&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f97a8f26",
  null
  
)

export default component.exports